export function initCookiePreferencesTrigger() {
    document.addEventListener("click", (e) => {
        const trigger = e.target.closest(
            ".open-cookie-settings a, a.open-cookie-settings, a.legal-open-cookie-settings"
        );
        
        if (!trigger) return;

        e.preventDefault();

        if (typeof CookieScript !== "undefined" && CookieScript.instance) {
            CookieScript.instance.showDetails();
        }
    });
}